import { Fraga } from "@/types/riskbedomning";

export const sakerhetSkyddFragor: Fraga[] = [
  {
    id: "fordon-trafik-sammansatt",
    text: "Finns det risk för sammanstötningar mellan fordon och personal samt trafikrisker?",
    kategori: "Säkerhetssystem & skydd",
    fas: "byggskede",
    followUpQuestions: [
      "Finns det separata gångvägar och körvägar för att minska kollisioner?",
      "Krävs hastighetsbegränsningar eller särskild trafikledning på arbetsplatsen?",
      "Är all personal utrustad med varselkläder och annan synlighetsutrustning?",
      "Behövs signalvakter eller andra säkerhetsåtgärder vid högt trafikflöde?",
      "Finns det risk att fysiska barriärer mellan arbetsområde och trafiken krävs men saknas?",
      "Finns det risk att nattarbete krävs och belysning inte hanteras korrekt?"
    ],
    afsReferences: ["AFS 2023:3", "AFS 2023:13"]
  },
  {
    id: "sakerhetsskydd-barriarer",
    text: "Hur utformas inhägnader för att effektivt hålla obehöriga ute?",
    kategori: "Säkerhetssystem & skydd",
    fas: "byggskede",
    followUpQuestions: [
      "Vilka tillträdesrutiner behöver implementeras?",
      "Riskerar besökare att vistas på arbetsplatsen utan tydliga säkerhetsrutiner?",
      "Riskerar arbetsområdet att vara oskyddat under tider utan aktivitet, såsom helger eller kvällar?",
      "Kan bristande samordning göra att skyddsåtgärder, avspärrningar eller bullerbegränsningar påverkar andra verksamheter, flöden eller personer på området?",
      "Kan bristande planering, skyltning eller blockering av tillträdesvägar för räddningstjänst och ambulans försvåra snabba insatser vid olycka eller brand?",
      "Kan avsaknad eller otydlig skyltning samt bristande fysiska skydd leda till att personal eller besökare utsätts för onödiga risker?",
      "Saknas skyddsräcken i särskilda riskområden?",
      "Saknas nöddusch/ögondusch där stänkrisk föreligger?"
    ],
    afsReferences: ["AFS 2023:3", "AFS 2023:13"]
  },
  {
    id: "farliga-amnen-brand",
    text: "Finns det risk för brister i hantering av farliga ämnen, kemikalier och brandrisker?",
    kategori: "Säkerhetssystem & skydd",
    fas: "byggskede",
    followUpQuestions: [
      "Finns lämpliga förvaringsutrymmen för farliga ämnen?",
      "Hur hanteras spill eller olyckshändelser med farliga ämnen?",
      "Finns uppdaterade säkerhetsdatablad tillgängliga för alla kemikalier?",
      "Har personal fått utbildning i säker hantering av de farliga ämnen som förekommer?",
      "Kan bristande tillgång till rätt typ av brandsläckningsutrustning – exempelvis handbrandsläckare, brandfiltar eller fasta system – öka risken för att en brand inte kan hanteras i tid?",
      "Finns det risk att explosionsrisker inte har identifierats?",
      "Riskerar farliga processer att orsaka förgiftning, brand eller explosion på arbetsplatsen?",
      "Riskerar arbete med farliga ämnen, svetsning eller damm att ske utan tillräckliga skyddsåtgärder?"
    ],
    afsReferences: ["AFS 2023:10"]
  },
  {
    id: "forsta-hjalpen-ensamarbete",
    text: "Riskerar första hjälpen-beredskap, ensamarbetsrutiner eller akutsjukvård att vara otillräckliga?",
    kategori: "Säkerhetssystem & skydd", 
    fas: "byggskede",
    followUpQuestions: [
      "Riskerar rutiner för krishantering och olycksrapportering att vara otydliga eller okända för personalen?",
      "Finns det risk att särskild sjukvårdsutrustning saknas på arbetsplatsen?",
      "Finns det risk att evakueringsplan vid allvarliga skador saknas?"
    ],
    afsReferences: ["AFS 2023:3", "AFS 2023:13"]
  },
  {
    id: "samordning-pse",
    text: "Vem ansvarar för säkerhetssamordningen mellan olika entreprenörer?",
    kategori: "Säkerhetssystem & skydd",
    fas: "byggskede",
    followUpQuestions: [
      "Kan brist på gemensamt språk, översatta instruktioner eller tolkstöd göra att säkerhetsinformation, skyltar och instruktioner inte förstås av alla entreprenörer och arbetstagare?",
      "Riskerar personlig skyddsutrustning att saknas eller inte motsvara kraven för aktuella arbetsmoment?"
    ],
    afsReferences: ["AFS 2023:3", "AFS 2023:13"]
  }
];